import { render } from "./PurchaseOperationModal.vue?vue&type=template&id=08181b49&ts=true"
import script from "./PurchaseOperationModal.vue?vue&type=script&lang=ts"
export * from "./PurchaseOperationModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__